import Vue from 'vue'
import { uploadExcel, importExl } from '@/api'

export default {
    namespaced: true,
    state: {
        excel: null,
        unloaded: true
    },
    mutations: {
        SET_FILE: (state, file) => state.excel = file,
        SET_UNLOAD: (state, bool) => state.unloaded = bool
    },
    actions: {
        prepare({ commit, rootGetters: { lang } }, file) {
            commit('SET_FILE', file)
        },
        upload({ state, commit }) {
            const data = new FormData();
            data.append('file', state.excel);

            return uploadExcel(data).then(() => {
                Vue.prototype.$notification.open({
                    message: 'Éxito!',
                    description: 'Se ha subido el archivo con éxito',
                    duration: 0,
                    icon: (h) => (<a-icon type="smile" style="color: #48BE83" />),
                });
                // Vue.prototype.$message.success(``, 0);
                commit('SET_UNLOAD', false)
            })
        },
        importExl() {
            return importExl()
                .then((response) => {
                    Vue.prototype.$notification.open({
                        message: 'Procesamiento de fichero Excel.',
                        description: 'El procesamiento del fichero Excel ha comenzado. Este proceso puede tardar varios minutos. Cuando finalice se enviará automáticamente un e-mail a su dirección de correo electrónico registrada en su perfil de usuario.',
                        duration: 0,
                        icon: (h) => (<a-icon type="smile" style="color: #48BE83" />),
                    });
                    return response
                    // Vue.prototype.$message.success(`Se ha procesado el archivo con éxito`, 0);
                })
        }
    },
    getters: {}
}